module.exports = __webpack_public_path__ + "static/bg02-3177925d8e55cf4cda99fb15bbc2be6b.jpg";